import { useSelector } from "react-redux";

const RealCashback = () => {
  let {
    data: { AuthorizationRCB },
  } = useSelector((state) => state.Login);
  AuthorizationRCB = AuthorizationRCB.replace("Bearer ", "");
  window.location.href = `${process.env.REACT_APP_REAL_CASHBACK_URL}/auth?token=${AuthorizationRCB}`;
  return null;
};

export default RealCashback;
